import {JsonObject, JsonProperty} from 'json2typescript';
import {DynamicValueFilter} from './dynamicValueFilter';
import {RespondentIdentification} from './respondentIdentification';

@JsonObject('DynamicDataRequestConfig')
export class DynamicDataRequestConfig {
    @JsonProperty('RespondentIdentification',RespondentIdentification,true)
    respondent_identification:RespondentIdentification = null;
    @JsonProperty('answers_filter',[String],true)
    answers_filter: string[] = [];
    @JsonProperty('dynamic_values_filter',DynamicValueFilter,true)
    dynamic_values_filter:DynamicValueFilter = null;
}
